export const SET_IS_REDESIGNED_FLOW = 'REDESIGNED_FLOW/SET_IS_REDESIGNED_FLOW';
export const SET_HEADER_SETTINGS = 'REDESIGNED_FLOW/SET_HEADER_SETTINGS';
